interface DiscountThreshold {
  minQuantity: number;
  discountPercent: number;
  description?: string;
  discountPrice: number;
}

interface DiscountRule {
  productSlugs: string[];
  title: string;
  description: string;
  thresholds: DiscountThreshold[];
}

const discountRules: DiscountRule[] = [
  {
    productSlugs: ['google-review-card', 'google-review-card-white', 'google-review-card-black'],
    title: 'store.discount.bulkDiscount',
    description: 'store.discount.saveMoreDescription',
    thresholds: [
      {
        minQuantity: 3,
        discountPercent: 18,
        description: 'store.discount.thresholds.off18for3',
        discountPrice: 49.0,
      },
      {
        minQuantity: 5,
        discountPercent: 30,
        description: 'store.discount.thresholds.off30for5',
        discountPrice: 69.0,
      },
    ],
  },
  {
    productSlugs: ['google-review-plate', 'google-review-plate-white', 'google-review-plate-black'],
    title: 'store.discount.bulkDiscount',
    description: 'store.discount.saveMoreDescription',
    thresholds: [
      {
        minQuantity: 2,
        discountPercent: 25,
        description: 'store.discount.thresholds.off25for2',
        discountPrice: 89.0,
      },
      {
        minQuantity: 5,
        discountPercent: 55,
        description: 'store.discount.thresholds.off55for5',
        discountPrice: 134.0,
      },
    ],
  },
  {
    productSlugs: ['google-review-stand', 'google-review-stand-white', 'google-review-stand-black'],
    title: 'store.discount.bulkDiscount',
    description: 'store.discount.saveMoreDescription',
    thresholds: [
      {
        minQuantity: 3,
        discountPercent: 33,
        description: 'store.discount.thresholds.off33for3',
        discountPrice: 99.0,
      },
      {
        minQuantity: 5,
        discountPercent: 50,
        description: 'store.discount.thresholds.off50for5',
        discountPrice: 124.0,
      },
    ],
  },
];

export { discountRules };
export type { DiscountRule, DiscountThreshold };
